import gql from 'graphql-tag';
import { apolloClient } from '@/apollo';

export default {
  state: {
    threadMessages: [],
    newThreadMessages: [],
    messageUserSubscription: null,
    attachments: [],
    selectedThread: null,
    activeThreadId: null,
    activeThreadIdReadStatus: null,
    messageSubscription: null,
    readStatusSubscription: null,
  },
  namespaced: true,
  mutations: {
    setThreadMessages(state, messages) {
      state.threadMessages = messages;
    },
    setNewThreadMessages(state, message) {
      if (message.isRead) {
        state.newThreadMessages = state.newThreadMessages.filter(messages => messages.id !== message.id)
      } else {
        state.newThreadMessages.push(message) ;
      }
	  },
    clearNewThreadMessages(state, messageId) {
      state.newThreadMessages = state.newThreadMessages.filter((message) => {
        return message.id !== messageId;
      });
    },
    setAttachments(state, attachments) {
      state.attachments = attachments;
    },
    deleteThread(state, threadId) {
      state.threadMessages = state.threadMessages.filter(message => message.thread_id !== threadId);
      state.newThreadMessages = state.newThreadMessages.filter(message => message.thread_id !== threadId);
    },
    setMessageUserSubscription(state, subscription) {
      state.messageUserSubscription = subscription;
    },
    clearMessageUserSubscription(state) {
      state.messageUserSubscription = null;
    },
    setSelectedThread(state, message) {
      state.selectedThread = message;
    },
    pushMessageToSelected(state, newMessage) {
      state.selectedThread.messages.push(newMessage);
    },

    setActiveThreadId(state, threadId) {
      state.activeThreadId = threadId;
    },
    setActiveThreadIdReadStatus(state, threadId) {
      state.activeThreadIdReadStatus = threadId;
    },
    setMessageSubscription(state, subscription) {
      state.messageSubscription = subscription;
    },
    clearMessageSubscription(state) {
      state.messageSubscription = null;
    },
    setReadStatusSubscription(state, subscription) {
      state.readStatusSubscription = subscription;
    },
    clearReadStatusSubscription(state) {
      state.readStatusSubscription = null;
    },
    updateRecipientRead(state, { messageId, recipientRead }) {
      const targetMessage = state.selectedThread.messages.find(msg => msg.message_id === messageId);
      if (targetMessage) {
        targetMessage.recipient_read = recipientRead;
      }
    },
  },
  actions: {
    async FETCH_MESSAGES({ commit, dispatch, rootState }) {
      try {
        const response = await apolloClient.query({
          query: gql`
              query {
                  listMessages {
                      thread_id
                      author_name
                      sender_type
                      sender_id
                      contact_user_id
                      contact_user_name
                      contact_user_type
                      affiliate_id
                      affiliate_name
                      status
                      preview
                      mute
                      countOfUnreadMessages
                      date_added
                      date_updated
                  }
              }
          `,
          context: {
            headers: {
              employee_id: rootState.user.user[0].employee_id,
            },
          },
          fetchPolicy: 'network-only',
        });

        // console.log('FETCH_MESSAGES :', response.data.listMessages);
        commit('setThreadMessages', response.data.listMessages);
      } catch (e) {
        console.error('listMessagesError:', e);
      }
    },
    async UPLOAD_ATTACHMENTS({ commit, dispatch, rootState }, { threadId, attachmentsUploads }) {

      try {
        const response = await apolloClient.mutate({
          mutation: gql`
              mutation($threadId: Int!, $attachmentsUploads: [String!]!) {
                  attachmentsUploads(threadId: $threadId, attachmentsUploads: $attachmentsUploads) {
                      fileName
                      threadId
                      presignedURL
                  }
              }
          `,
          variables: {
            threadId,
            attachmentsUploads,
          },
          context: {
            headers: {
              employee_id: rootState.user.user[0].employee_id,
            },
          },
        });

        commit('setAttachments', response.data.attachmentsUploads);
      } catch (e) {
        console.error('attachmentsUploadsError:', e);
        dispatch('alert/ALERT_ERROR', e.message, {root: true});
      }
    },
    async DELETE_THREAD({ commit, dispatch, rootState }, threadId) {
      try {
        const response = await apolloClient.mutate({
          mutation: gql`
              mutation($threadId: Int!) {
                  deleteThread(thread_id: $threadId) {
                      message
                      success
                  }
              }
          `,
          variables: {
            threadId
          },
          context: {
            headers: {
              employee_id: rootState.user.user[0].employee_id,
            },
          },
        });

        if (response.data.deleteThread.success) {
          dispatch('alert/ALERT_SUCCESS', 'Thread was deleted successfully ',  {root: true});
          commit('deleteThread', threadId);

        } else {

          console.error('deleteThreadError:', response.data.deleteThread.message);
          dispatch('alert/ALERT_ERROR', response.data.deleteThread.message, {root: true});
        }
      } catch (e) {
        console.error('deleteThreadException:', e);
        dispatch('alert/ALERT_ERROR', e.message, {root: true});
      }
    },
    async SUBSCRIBE_USER_TO_MESSAGES({ commit, dispatch, rootState }, managerId) {
      console.log(`[SUBSCRIBE_USER_TO_MESSAGES] by managerId: ${managerId} employee_id ${ rootState.user.user[0].employee_id}`);
      dispatch('UNSUBSCRIBE_USER_FROM_MESSAGES');
      const subscription = apolloClient.subscribe({
        query: gql`
            subscription ($recipient_id: Int!) {
                readUserMessages(recipient_id: $recipient_id) {
                    id
                    thread_id
                    message
                    author_name
                    author_type
                    date_added
                    recipient_read
                    attachments {
                        name
                        url
                    }
                }
            }
        `,
        variables: {
          recipient_id: parseInt(managerId),
          employee_id: rootState.user.user[0].employee_id,
        },
        fetchPolicy: "network-only",
      }).subscribe({
        next: ({ data }) => {
          const newMessage = data.readUserMessages;
          console.log(`Subscription [READ_USER_MESSAGES] get new message ${JSON.stringify(newMessage)} `);
          commit('setNewThreadMessages', newMessage);
        },
        error: (error) => {
          console.error("Error in readUserMessages subscription", error);
        },
      });
      commit('setMessageUserSubscription', subscription);
    },
    UNSUBSCRIBE_USER_FROM_MESSAGES({ commit, state }) {
      if (state.messageUserSubscription) {
        state.messageUserSubscription.unsubscribe();
        commit('clearMessageUserSubscription');
      }
    },
    async FETCH_THREAD_MESSAGES({ commit, dispatch, state, rootState }) {
      if (state.selectedThread) {
        const threadId = state.selectedThread.thread_id;
        const response = await apolloClient.query({
          query: gql`
              query ($threadId: Int!) {
                  readMessagesThread(thread_id: $threadId) {
                      thread {
                          id
                          affiliate_id
                          affiliate_name
                          contact_user_id
                          contact_user_name
                          contact_user_type
                          mute
                          messages {
                              author_id
                              author_type
                              author_name
                              date_added
                              recipient_read
                              message
                              message_id
                              attachments {
                                  name
                                  url
                              }
                          }
                      }
                  }
              }
          `,
          variables: {
            threadId: parseInt(threadId),
          },
          context: {
            headers: {
              employee_id: rootState.user.user[0].employee_id,
            },
          },
          fetchPolicy: 'network-only',
        });

        const threadData = response.data.readMessagesThread.thread;

        const selectedThread = {
          ...threadData,
          messages: threadData.messages.map(message => ({
            ...message,
            date_added_local: new Date(message.date_added * 1000)
          }))
        };

        commit('setSelectedThread', selectedThread);

        if (threadId) {
          dispatch('SUBSCRIBE_TO_MESSAGES', parseInt(threadId));
          dispatch('SUBSCRIBE_TO_READ_STATUS', parseInt(threadId));
        }
      }
    },
    async SUBSCRIBE_TO_MESSAGES({ commit, state, dispatch, rootState}, threadId) {

      if (state.activeThreadId === threadId) return;
      dispatch('UNSUBSCRIBE_FROM_MESSAGES');

      console.log(`[SUBSCRIBE_TO_MESSAGES] by threadId: ${threadId}`);

      const messageSubscription = apolloClient.subscribe({
        query: gql`
            subscription ($threadId: Int!) {
                readMessages(thread_id: $threadId) {
                    id
                    thread_id
                    message
                    author_name
                    author_type
                    date_added
                    recipient_read
                    attachments {
                        name
                        url
                    }
                }
            }
        `,
        variables: {
          threadId: parseInt(threadId),
          employee_id: rootState.user.user[0].employee_id,  // Adjusted access to user from rootState
        },
      }).subscribe({
        next: ({ data }) => {
          const newMessage = data.readMessages;
          if (state.selectedThread && Array.isArray(state.selectedThread.messages)) {

            if (!newMessage.message_id) {
              newMessage.message_id = newMessage.id;
            }
            commit('pushMessageToSelected', newMessage);
            console.log(`Subscription [READ_MESSAGES]  get new message  ${JSON.stringify(newMessage)} to messages` );
          }

        },
        error: (error) => {
          console.error('Error in readMessages subscription', error);
        },
      });

      commit('setMessageSubscription', messageSubscription);
      commit('setActiveThreadId', threadId);
    },
    UNSUBSCRIBE_FROM_MESSAGES({ commit, state }) {
      if (state.messageSubscription) {
        state.messageSubscription.unsubscribe();
        commit('clearMessageSubscription');
      }
    },
    async SUBSCRIBE_TO_READ_STATUS({ commit, state, dispatch, rootState }, threadId) {
      if (state.activeThreadIdReadStatus === threadId) return;
      dispatch('UNSUBSCRIBE_FROM_READ_STATUS');
      console.log(`[SUBSCRIBE_TO_MESSAGES_READ_STATUS] by threadId: ${threadId}`);
      const readStatusSubscription = apolloClient.subscribe({
        query: gql`
            subscription MessageReadStatusChanged($threadId: Int!) {
                messageReadStatusChanged(thread_id: $threadId) {
                    message_id
                    recipient_read
                }
            }
        `,
        variables: {
          threadId: parseInt(threadId),
        },
      }).subscribe({
        next: ({ data }) => {
          const readStatusUpdate = data.messageReadStatusChanged;
          if (state.selectedThread && Array.isArray(state.selectedThread.messages)) {
            const targetMessage = state.selectedThread.messages.find(msg => msg.message_id === readStatusUpdate.message_id);
            if (targetMessage) {
              commit('updateRecipientRead', { messageId: targetMessage.message_id, recipientRead: readStatusUpdate.recipient_read });
            }
          }
        },
        error: (error) => {
          console.error('Error in read status subscription', error);
        },
      });

      commit('setReadStatusSubscription', readStatusSubscription);
      commit('setActiveThreadIdReadStatus', threadId);
    },
    UNSUBSCRIBE_FROM_READ_STATUS({ commit, state }) {
      if (state.readStatusSubscription) {
        state.readStatusSubscription.unsubscribe();
        commit('clearReadStatusSubscription');
      }
    },
    async CREATE_THREAD({ commit, state, dispatch }, params) {
      let mutationQuery = `
        mutation SendMessage(
          $senderId: Int!
          $senderType: String!
          $recipientId: Int!
          $recipientType: String!
          $message: String!
        ) {
          sendMessage(
            sender_id: $senderId
            sender_type: $senderType
            recipient_id: $recipientId
            recipient_type: $recipientType
            message: $message
          ) {
            thread_id
            id
            message
          }
        }
      `;
      try {
        const response = await apolloClient.mutate({
          mutation: gql(mutationQuery),
          variables: {
            senderId: params.senderId,
            senderType: 'manager',
            recipientId: params.recipientId,
            recipientType: 'affiliate',
            message: params.message,
          },
          context: {
            headers: {
              employee_id: params.employeeId,
            },
          },
        });
        console.log('Message sent:', response.data.sendMessage);
        if (response.data.sendMessage.thread_id) {
          await dispatch('FETCH_MESSAGES');
        }

      } catch (e) {
        dispatch('alert/ALERT_ERROR', e.message, {root: true});
      }
    },
    async SEND_MESSAGE({ state , dispatch}, params) {
      const {senderId, threadId, attachments, recipientId, message, employeeId} = params;
      let attachmentsPart = '';
      if (attachments && attachments.length > 0) {
        attachmentsPart = `
        attachments: $attachments
      `;
      }

      let mutationQuery = `
        mutation SendMessage(
            $senderId: Int!
            $senderType: String!
            $recipientId: Int!
            $recipientType: String!
            $message: String!
            ${threadId ? '$threadId: Int!' : ''}
            ${attachments && attachments.length > 0 ? '$attachments: [String!]!' : ''}
        ) {
            sendMessage(
                sender_id: $senderId
                sender_type: $senderType
                recipient_id: $recipientId
                recipient_type: $recipientType
                message: $message
                ${threadId ? 'thread_id: $threadId' : ''}
                ${attachmentsPart}
            ) {
                thread_id
                id
                ${attachments && attachments.length > 0 ? 'attachments { name url }' : ''}
            }
        }
      `;

      try {
        const response = await apolloClient.mutate({
          mutation: gql(mutationQuery),
          variables: {
            senderId: senderId,
            senderType: 'manager',
            recipientId: recipientId,
            recipientType: 'affiliate',
            message: message,
            ...(threadId && {threadId: parseInt(threadId)}),
            ...(attachments && attachments.length > 0 && {attachments: attachments}),
          },
          context: {
            headers: {
              employee_id: employeeId,
            },
          },
        });

        console.log('Message sent:', response.data.sendMessage);

      } catch (e) {
        dispatch('alert/ALERT_ERROR', e.message, {root: true});
      }
    },
    async MARK_THREAD_AS_READ({ state, dispatch }, params) {
      const { threadId, employeeId } = params;
      try {
        const mutationQuery = `
          mutation MarkAsReadThread($threadId: Int!) {
            markAsReadThread(thread_id: $threadId) {
              success
            }
          }
        `;

        const response = await apolloClient.mutate({
          mutation: gql(mutationQuery),
          variables: {
            threadId: threadId,
          },
          context: {
            headers: {
              employee_id: employeeId,
            },
          },
        });

        console.log('[MarkAsReadThread]:', response.data.markAsReadThread.success);
      } catch (e) {
        dispatch('alert/ALERT_ERROR', e.message, {root: true});
      }
    }
  },
  getters: {
    getThreadMessages(state) {
      return state.threadMessages;
    },
    getNewThreadMessages(state) {
      return state.newThreadMessages;
    },
    getAttachments(state) {
      return state.attachments;
    },
    getSelectedThread(state) {
      return state.selectedThread;
    },
  },
};
